var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvilableRecordsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4468 3.44152L17.6861 4.1H18.3867H24.8889C26.0511 4.1 27 5.05065 27 6.2V27.9C27 29.0493 26.0511 30 24.8889 30H3.11111C1.94891 30 1 29.0493 1 27.9V6.2C1 5.05065 1.94891 4.1 3.11111 4.1H9.61333H10.3139L10.5532 3.44152C11.0708 2.01697 12.4212 1 14 1C15.5788 1 16.9292 2.01697 17.4468 3.44152ZM13.2942 27.0584L14 27.7617L14.7058 27.0584L22.4836 19.3084L24.1981 17.6H21.7778H18.1111V12.4V11.4H17.1111H10.8889H9.88889V12.4V17.6H6.22222H3.80189L5.51638 19.3084L13.2942 27.0584ZM16.5556 4.65C16.5556 3.24184 15.4045 2.1 14 2.1C12.5955 2.1 11.4444 3.24184 11.4444 4.65C11.4444 6.05815 12.5955 7.2 14 7.2C15.4045 7.2 16.5556 6.05815 16.5556 4.65Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvilableRecordsIcon);
export default __webpack_public_path__ + "static/media/AvilableRecordsIcon.f52ab7e3da50aa22849d98d8b39912aa.svg";
export { ForwardRef as ReactComponent };